import { Nullable } from '@aibees/shared/definition';
import { SocialLink } from '../components';
import {
  Company,
  CompanyLocationsInfo,
  CompanySummary,
} from '../feature/search-table-company';

export interface GetCompaniesParam {
  return?: string;
  search?: string;
}

export interface CompanySearchItem {
  canSimilaritySearch: boolean;
  id?: string;
  summary?: {
    name: CompanySummary['name'];
    logo: CompanySummary['logo'];
    industry: CompanySummary['industry'];
    staff: CompanySummary['staff'];
    type: CompanySummary['type'];
  };
  location?: {
    headquarter: CompanyLocationsInfo['headquarter'];
  };
  link: Nullable<SocialLink>;
  keywords: Company['keywords'];
}

export interface CompanyMetadataItem {
  id: string;
  name: string;
  logo: string;
  url: string;
}

export enum CompanySocialMedia {
  LINKEDIN = 'LINKEDIN',
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  INSTAGRAM = 'INSTAGRAM',
}
